// extracted by css-extract-rspack-plugin
export default {"ReactionsMenuOption":"ReactionsMenuItem-module__ReactionsMenuOption__oqUPO","viewerHasReacted":"ReactionsMenuItem-module__viewerHasReacted__UFHOu"};